export enum ResearchSufficiencyOutcome {
  SUFFICIENT = "sufficient",
  INSUFFICIENT = "insufficient",
}
